import { SERVICES } from '@shared/constants/apiConfig';
import { Roles } from '@shared/constants/constants';
import { IOption } from '@shared/interfaces';

export const roleByNameUrl = `/${SERVICES.USER}/roleAssignment/roleByName`;

export const roleByName = [
  Roles.SDR_DEAL_USER,
  Roles.LC,
  Roles.LCA,
  Roles.LP,
  Roles.ACCOUNING,
  Roles.BANK,
  Roles.TITLES,
];

export interface IDropdownUsersProps {
  sdrUserSelectOptions: IOption[];
  lcUserSelectOptions: IOption[];
  lcaUserSelectOptions: IOption[];
  bankUserSelectOptions: IOption[];
  lpUsersUserSelectOptions: IOption[];
  accountingUsersUserSelectOptions: IOption[];
  titlesUsersUserSelectOptions: IOption[];
}

export interface IDropdownPropsWithMutation {
  userSelectOptions: IDropdownUsersProps | IOption[];
}
